// extracted by mini-css-extract-plugin
module.exports = {"group":"billingProgress_group__2phkv","ringWrapper":"billingProgress_ringWrapper__-kW4Y","centerText":"billingProgress_centerText__KsKvN","label":"billingProgress_label__3kd3G"};